<template>
  <div class="">
    <div class="hidden-xs-only hidden-sm-and-down bg-nosotros-2" data-aos="fade-right">
      <el-row :gutter="20" style="padding: 0px 0%"
        ><el-col :md="24"
          ><h2 class="title_desarrollo">{{ $t('social.titulo') }}</h2></el-col
        ></el-row
      >
      <el-row :gutter="20"
        ><el-col :md="24" style="margin-top: 0px; margin-bottom: 15px"><p class="msj_cultura" v-html="$t('social.mensaje')"></p></el-col
      ></el-row>

      <el-row :gutter="20">
        <el-col :md="12" style="margin-bottom: 15px; text-align: center"
          ><div class="block">
            <el-image :src="pages2[0]" style="width: 50%; box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2)" @click="getRevista(2)"></el-image>
            <br />
            <el-button class="demonstration" @click="descargar_revista2()" style="border: none" :loading="loadRevista2"
              ><a class="demonstration loading-link" style="text-decoration: none" href="/newlog/documentos/RSE LOG-IN 2024.pdf" download> {{ $t('social.reporte_2') }}</a></el-button
            >
          </div></el-col
        ><el-col :md="12" style="margin-bottom: 15px; text-align: center">
          <div class="block">
            <el-image :src="pages[0]" style="width: 50%; box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2)" @click="getRevista(1)"></el-image>
            <!-- <el-link class="demonstration" :underline="false" :loading="loadRevista">{{ $t('social.reporte_1') }}</el-link> -->
            <br />
            <el-button class="demonstration" @click="descargar_revista(1)" style="border: none" :loading="loadRevista"
              ><a class="demonstration loading-link" style="text-decoration: none" href="/newlog/documentos/RSE LOG-IN 2023.pdf" download> {{ $t('social.reporte_1') }}</a></el-button
            >
            <!-- <p class="demonstration" @click="descargar_revista(1)">{{ $t('social.reporte_1') }}</p> -->
          </div>
        </el-col></el-row
      >

      <!-- <el-row
      ><el-col> <FullScreenFlipbook :pages="pages" /> </el-col
    ></el-row> -->

      <el-dialog
        top="5px"
        :modal="false"
        :close-on-press-escape="true"
        :visible.sync="showRevista"
        class="dialog-title"
        :title="$t('social.reporte_1')"
        style="text-align: center; font-family: 'roboto'"
        @opened="onOpenedRevista1">
        <el-row>
          <el-col :md="24" style="margin-bottom: 15px">
            <div class="flipbook-container" v-if="showRevista">
              <!-- Controles -->
              <div class="controls">
                <el-tooltip class="item" effect="dark" :content="palabraD" placement="bottom">
                  <el-button type="danger" :loading="loadRevista" circle
                    ><a class="loading-link" style="text-decoration: none" href="/newlog/documentos/RSE LOG-IN 2023.pdf" download> <i class="el-icon-download"></i> </a></el-button
                ></el-tooltip>
                <el-tooltip class="item" effect="dark" content="Zoom (-)" placement="bottom"><el-button @click="zoomOut" icon="el-icon-minus" circle></el-button></el-tooltip>
                <el-tooltip class="item" effect="dark" content="Zoom (+)" placement="bottom"><el-button @click="zoomIn" icon="el-icon-plus" circle></el-button></el-tooltip>
                <el-tooltip class="item" effect="dark" :content="palabraDer" placement="bottom"><el-button @click="prevPage" icon="el-icon-back" circle></el-button></el-tooltip>
                <el-tooltip class="item" effect="dark" :content="palabraIzq" placement="bottom"><el-button @click="nextPage" icon="el-icon-right" circle></el-button></el-tooltip>
                <el-tooltip class="item" effect="dark" :content="palabraC" placement="bottom"
                  ><el-button class="close-btn" @click="closeFlipbook" icon="el-icon-close" circle></el-button
                ></el-tooltip>
              </div>

              <!-- Flipbook -->
              <flipbook
                v-if="renderFlipbook && showRevista"
                ref="flipbook"
                class="flipbook"
                :style="{ transform: `scale(${zoom})` }"
                :pages="pages"
                :start-page="currentPage"
                :flip-duration="700"
                :zooms="null">
              </flipbook>
            </div>
          </el-col>
        </el-row>
      </el-dialog>
      <el-dialog
        top="5px"
        :modal="false"
        :close-on-press-escape="true"
        :visible.sync="showRevista2"
        class="dialog-title"
        :title="$t('social.reporte_2')"
        style="text-align: center; font-family: 'roboto'; color: #d35400 !important">
        <el-row>
          <el-col :md="24" style="margin-bottom: 15px">
            <div class="flipbook-container" v-if="showRevista2">
              <div class="controls">
                <el-tooltip class="item" effect="dark" :content="palabraD" placement="bottom">
                  <el-button type="danger" :loading="loadRevista" circle
                    ><a class="loading-link" style="text-decoration: none" href="/newlog/documentos/RSE LOG-IN 2024.pdf" download> <i class="el-icon-download"></i> </a></el-button
                ></el-tooltip>
                <el-tooltip class="item" effect="dark" content="Zoom (-)" placement="bottom"><el-button @click="zoomOut" icon="el-icon-minus" circle></el-button></el-tooltip>
                <el-tooltip class="item" effect="dark" content="Zoom (+)" placement="bottom"><el-button @click="zoomIn" icon="el-icon-plus" circle></el-button></el-tooltip>
                <el-tooltip class="item" effect="dark" :content="palabraDer" placement="bottom"><el-button @click="prevPage" icon="el-icon-back" circle></el-button></el-tooltip>
                <el-tooltip class="item" effect="dark" :content="palabraIzq" placement="bottom"><el-button @click="nextPage" icon="el-icon-right" circle></el-button></el-tooltip>
                <el-tooltip class="item" effect="dark" :content="palabraC" placement="bottom"
                  ><el-button class="close-btn" @click="closeFlipbook" icon="el-icon-close" circle></el-button
                ></el-tooltip>
              </div>
              <flipbook
                v-if="showRevista2"
                ref="flip1"
                class="flipbook"
                :pages="pages2"
                :style="{ transform: `scale(${zoom})` }"
                :start-page="currentPage"
                :flip-duration="700"
                :zooms="null" />
            </div>
            ></el-col
          >
        </el-row>
      </el-dialog>
    </div>
    <div class="hidden-md-and-up bg-nosotros-2" data-aos="fade-right">
      <el-row :gutter="20" style="padding: 0px 0%"
        ><el-col :md="24"
          ><h2 class="title_desarrollo">{{ $t('social.titulo') }}</h2></el-col
        ></el-row
      >
      <el-row :gutter="20"
        ><el-col :md="24" style="margin-top: 0px; margin-bottom: 15px"><p class="msj_cultura" style="sp" v-html="$t('social.mensaje_phone')"></p></el-col
      ></el-row>

      <el-row :gutter="20">
        <el-col :md="12" style="margin-bottom: 15px; text-align: center"
          ><div class="block">
            <el-image :src="pages2[0]" style="width: 50%; box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2)" @click="abrirPdf(2)"></el-image>
            <p class="demonstration">
              <a class="demonstration" href="/newlog/documentos/RSE LOG-IN 2024.pdf" download> {{ $t('social.reporte_2') }}</a>
            </p>
          </div></el-col
        ><el-col :md="12" style="margin-bottom: 15px; text-align: center">
          <div class="block">
            <el-image :src="pages[0]" style="width: 50%; box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2)" @click="abrirPdf(1)"></el-image>
            <!-- <p class="demonstration" @click="descargar_revista(1)">{{ $t('social.reporte_1') }}</p> -->
            <p class="demonstration">
              <a class="demonstration loading-link" href="/newlog/documentos/RSE LOG-IN 2023.pdf" download> {{ $t('social.reporte_1') }}</a>
            </p>
          </div>
        </el-col></el-row
      >
    </div>
  </div>
</template>
<script>
// import accounting from 'accounting'
// import ICountUp from 'vue-countup-v2'
import AOS from 'aos'
import 'aos/dist/aos.css'
import Flipbook from 'flipbook-vue/dist/vue2/flipbook.mjs'
// import FullScreenFlipbook from './flipbookFullscren.vue'
import { EventBus } from '@/event-bus.js'

// Importa automáticamente todas las páginas JPG del directorio
function importAll(r) {
  return r.keys().map(r)
}
export default {
  components: { Flipbook },

  data() {
    return {
      pages: importAll(require.context('@/assets/pdf-pages', false, /\.jpg$/)),
      pages2: importAll(require.context('@/assets/pdf-pages-2', false, /\.jpg$/)),
      showRevista: false,
      showRevista2: false,
      zoom: 0.7, // nivel de zoom inicial
      showFlipbook: false,
      visible: false,
      currentPage: 0,
      renderFlipbook: false,
      loadRevista: false,
      loadRevista2: false,
      palabraD: null,
      palabraDer: null,
      palabraIzq: null,
      palabraC: null,
    }
  },

  mounted() {
    AOS.init({
      duration: 1000,
      offset: 100,
      once: false, // false = animaciones se repiten al volver a scrollear
    })
    EventBus.$on('change-lenguaje', (lenguaje) => {
      this.palabraD = lenguaje === 'es' ? 'Descargar' : 'Download'
      this.palabraDer = lenguaje === 'es' ? 'Derecha' : 'Right'
      this.palabraIzq = lenguaje === 'es' ? 'Izquierda' : 'Left'
      this.palabraC = lenguaje === 'es' ? 'Cerrar' : 'Close'
    })
    this.palabraD = this.$i18n.locale === 'es' ? 'Descargar' : 'Download'
    this.palabraDer = this.$i18n.locale === 'es' ? 'Derecha' : 'Right'
    this.palabraIzq = this.$i18n.locale === 'es' ? 'Izquierda' : 'Left'
    this.palabraC = this.$i18n.locale === 'es' ? 'Cerrar' : 'Close'
  },
  beforeDestroy() {
    EventBus.$off('change-lenguaje', false)
  },
  methods: {
    zoomIn() {
      this.zoom += 0.1
    },
    zoomOut() {
      if (this.zoom > 0.3) this.zoom -= 0.1
    },

    nextPage() {
      // console.log('REFS flipbook raw:', this.$refs.flipbook)
      this.$refs.flipbook.flipRight()
    },
    prevPage() {
      this.$refs.flipbook.flipLeft()
    },

    closeFlipbook() {
      this.showRevista = false
      this.showRevista2 = false
      // Si querés emitir un evento al padre:
      this.$emit('closed')
    },
    getRevista(revista) {
      this.renderFlipbook = true
      if (revista == 1) {
        this.showRevista = true
        this.showRevista2 = false
      } else {
        this.showRevista2 = true
        this.showRevista = false
      }
    },
    onOpenedRevista1() {
      this.renderFlipbook = true
      this.$nextTick(() => {
        // forzar repaint/colocar en página 0 que tiende a fijar el render
        this.$refs.flipbook?.turnToPage?.(0)
      })
    },
    descargar_revista() {
      this.loadRevista = true
      // this.url = 'https://ns.suizoargentina.com/public/documentos/codigo.pdf'
      // // window.location.href = this.url

      // const fileName = 'codigo.pdf'
      // const url = window.URL.createObjectURL(new Blob(this.url))
      // const link = document.createElement('a')
      // link.href = url
      // //const contentDisposition = response.headers['content-disposition']

      // link.setAttribute('download', fileName)
      // document.body.appendChild(link)
      // link.click()
      // link.remove()
      // window.URL.revokeObjectURL(url)
      setTimeout(() => {
        this.loadRevista = false
      }, 2000)
    },
    descargar_revista2() {
      this.loadRevista2 = true

      setTimeout(() => {
        this.loadRevista2 = false
      }, 2000)
    },
    abrirPdf(tipo) {
      let url = tipo === 1 ? 'https://ns.suizoargentina.com/newlog/documentos/RSE%20LOG-IN%202023.pdf' : 'https://ns.suizoargentina.com/newlog/documentos/RSE%20LOG-IN%202024.pdf'
      const link = document.createElement('a')
      link.href = url
      link.target = '_blank'
      link.rel = 'noopener noreferrer'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
  },
}
</script>
<style scoped>
.el-button:focus,
.el-button:hover {
  color: #d35915;
  border-color: transparent;
  background-color: transparent;
}
.page img {
  position: absolute;
  backface-visibility: hidden;
  width: 60vh !important;
  height: 78vh !important;
  left: 857.5px !important;
  top: 0px !important;
  object-fit: contain;
}
.flipbook-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff; /* fondo oscuro */
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  /* width: 387px;
  height: 547px;
  left: -195px;
  top: 171px; */
}

.flipbook {
  width: 90%;
  height: 95%;
  transition: transform 0.3s ease;
  box-shadow: 0 0 20px rgb(255, 255, 255);
  border-radius: 12px;
  background: #d2591454;
  margin-top: -5%;
  object-fit: contain;
  top: 29px;
}
.fixed,
.page {
  top: 29px !important;
}
/* Botones flotantes */
.controls {
  position: absolute;
  top: 5%;
  /* right: 10%; */
  left: 40%;
  display: flex;
  gap: 8px;
  z-index: 100;
}

.controls button,
.controls icon {
  /* background: rgba(255, 255, 255, 0.15); */
  background: #d35915;
  color: #fff;
  border: none;
  /* border-radius: 50%; */
  /* width: 40px; */
  /* height: 40px; */
  font-size: 20px;
  cursor: pointer;
  transition: background 0.2s;
}

.controls button:hover {
  background: rgba(255, 255, 255, 0.3);
}
.controls .el-icon-download:hover {
  color: #d25914;
}
.controls a {
  color: white;
}
.dialog-title >>> .el-dialog__title {
  line-height: 24px;
  font-size: 18px;
  color: #d35400 !important;
  margin-top: 10px !important;
}
.button-group >>> .el-button {
  margin: 5px;
  border-color: #ccc;
}

/* estilo cuando el botón está seleccionado */
.button-group >>> .active-button {
  color: #fff !important;
  background-color: #d35400 !important;
  border-color: #e9eef3 !important;
}
/* .button-left >>> .el-button:hover,
.button-left >>> .el-button:active {
  color: #fff !important;
  border-color: #e9eef3;
  background-color: #d35400;
} */
</style>
<style>
.flipbook-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 90vh;
  background: #f4f4f4;
}

/* .flipbook {
  height: 550px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
} */
.demonstration {
  margin-top: 20px;
  color: #d35400;
  font-family: 'roboto-black';
  font-size: 20px;
  text-decoration: none;
}
.demonstration:hover {
  margin-top: 20px;
  color: #d35400;
  background-color: transparent;
  font-family: 'roboto-black';
}
.card-css {
  border-radius: 4px;
  border: 1px solid #d35400 !important;
  background-color: transparent !important;
}
.valores-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border: 1px solid #d35400;
  border-radius: 0 0 8px 8px;
  background-color: transparent;
  padding: 30px 20px 20px;
  position: relative;
  overflow: visible;
  border-bottom-left-radius: 60px;
}

.respondable-style {
  padding: 4% 10% 3% 10%;
}
@media (min-width: 2561px) {
  .respondable-style {
    padding: 4% 10% 0% 10%;
  }
  .controls {
    position: absolute;
    top: 20%;
    right: 0%;
    display: flex;
    gap: 8px;
    z-index: 100;
  }
}
@media screen and (min-width: 1920px) and (max-width: 2560px) {
  .respondable-style {
    padding: 4% 10% 0% 10%;
  }
  .controls {
    position: absolute;
    top: 20%;
    right: 6%;
    display: flex;
    gap: 8px;
    z-index: 100;
  }
}
@media screen and (min-width: 1440px) and (max-width: 1919px) {
  /* .valor .icono {
    transform: translateX(-200%);
  } */
  .controls {
    position: absolute;
    top: 2%;
    right: 6%;
    display: flex;
    gap: 8px;
    z-index: 100;
  }
}
@media screen and (min-width: 1023px) and (max-width: 1439px) {
  .respondable-style {
    padding: 5% 10% 0% 10%;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  /* .valor .icono {
    transform: translateX(-150%);
  } */
}
@media screen and (min-width: 599px) and (max-width: 767px) {
  .el-dialog__body {
    overflow: visible !important;
  }
  .el-dialog {
    width: 100% !important;
    margin: 0 !important;
    max-width: 100% !important;
  }

  .flipbook-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .flipbook {
    width: 100%;
    min-width: 260px; /* evitar width 0 en celular */
    min-height: 350px;
  }

  .controls {
    top: 5%;
    right: 2%;
    flex-wrap: wrap;
    justify-content: center;
  }
  .page {
    width: 387px;
    height: 547px;
    left: -174px !important;
    top: 140px !important;
  }
  .flipbook {
    width: 90%;
    height: 100%;
    transition: transform 0.3s ease;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.4);
    border-radius: 12px;
    /* background: #222; */
    margin-top: -100px;
  }
  .respondable-style {
    padding: 10%;
  }
}
@media screen and (min-width: 480px) and (max-width: 598px) {
  .respondable-style {
    padding: 10%;
  }
}
@media screen and (min-width: 376px) and (max-width: 480px) {
  .respondable-style {
    padding: 12% 10%;
  }
}

@media (max-width: 375px) {
  .respondable-style {
    padding: 12% 10%;
  }
}
</style>
